/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { FtpServer } from "./FtpServer";
import * as t from "io-ts";

// required attributes
const FtpServersR = t.interface({
  ftp_servers: t.readonlyArray(FtpServer, "array of FtpServer")
});

// optional attributes
const FtpServersO = t.partial({});

export const FtpServers = t.intersection(
  [FtpServersR, FtpServersO],
  "FtpServers"
);

export type FtpServers = t.TypeOf<typeof FtpServers>;
